module.exports = __webpack_public_path__ + "img/clarity.377295f.webp";